<template>
<TSTShell />
</template>

<script>
import TSTShell from './components/main/TSTShell.vue'

export default {
    name: 'App',
    components: {
        TSTShell
    },
    data() {
        return {}
    }
}
</script>

<style>
#app {
    font-size: 1vw;
}
</style>
